import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';
import { Circle } from 'lucide-react';
import { cn } from '../../utils/cn';

const RadioGroup = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <RadioGroupPrimitive.Root
            className={cn('flex flex-col gap-3', className)}
            {...props}
            ref={ref}
        />
    );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

// Figma node: 4004:45868 - Radio Group Item
const RadioGroupItem = React.forwardRef(
    ({ className, children, ...props }, ref) => {
        return (
            <RadioGroupPrimitive.Item
                ref={ref}
                className={cn(
                    'group relative flex items-start gap-3 rounded-[10px] border p-3 bg-card cursor-pointer transition-all',
                    'border-border hover:border-muted-foreground/50',
                    'focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring focus-visible:ring-offset-2',
                    'data-[state=checked]:border-primary data-[state=checked]:bg-primary/5',
                    'disabled:cursor-not-allowed disabled:opacity-50',
                    className,
                )}
                {...props}
            >
                <div className="relative flex h-4 w-4 shrink-0 items-center justify-center">
                    <div
                        className={cn(
                            'h-4 w-4 rounded-full border transition-all flex items-center justify-center',
                            'border-border bg-background',
                            'group-data-[state=checked]:border-primary group-data-[state=checked]:bg-primary',
                        )}
                    >
                        <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
                            <Circle className="h-2 w-2 fill-background text-background" />
                        </RadioGroupPrimitive.Indicator>
                    </div>
                </div>
                {children && <div className="flex-1">{children}</div>}
            </RadioGroupPrimitive.Item>
        );
    },
);
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

// Simple radio item without card styling
const RadioGroupSimpleItem = React.forwardRef(
    ({ className, ...props }, ref) => {
        return (
            <RadioGroupPrimitive.Item
                ref={ref}
                className={cn(
                    'aspect-square h-4 w-4 rounded-full border border-border bg-background text-primary shadow-sm flex items-center justify-center',
                    'focus:outline-none focus-visible:ring-[3px] focus-visible:ring-ring focus-visible:ring-offset-2',
                    'disabled:cursor-not-allowed disabled:opacity-50',
                    'data-[state=checked]:border-primary data-[state=checked]:bg-primary',
                    className,
                )}
                {...props}
            >
                <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
                    <Circle className="h-2 w-2 fill-background text-background" />
                </RadioGroupPrimitive.Indicator>
            </RadioGroupPrimitive.Item>
        );
    },
);
RadioGroupSimpleItem.displayName = 'RadioGroupSimpleItem';

export { RadioGroup, RadioGroupItem, RadioGroupSimpleItem };
